/**
 * Colyseus endpoint resolution:
 * - VITE_COLYSEUS_URL env wins (set per Cloudflare Pages environment later).
 * - Otherwise assume a dev server on :2567 of the page's host — works for
 *   localhost and for phones on the LAN hitting the dev box.
 *
 * The 0.17 SDK wants an http(s) URL (it negotiates the websocket itself).
 */
const PRODUCTION_ENDPOINT = "https://server.actuniverse.com";

export function resolveColyseusEndpoint(): string {
  const fromEnv = import.meta.env.VITE_COLYSEUS_URL as string | undefined;
  if (fromEnv && fromEnv.length > 0) return fromEnv;
  if (import.meta.env.PROD) return PRODUCTION_ENDPOINT;
  const protocol = location.protocol === "https:" ? "https" : "http";
  return `${protocol}://${location.hostname}:2567`;
}
